import axios from '../axios';

/**
 * 开启关闭分账
 * @param {*} data 
 * id	String	是	string
    isShare	是	string	是否开通分账 Y:开通 N:关闭
 * @wiki http://wiki.sdjpw.com.cn/pages/viewpage.action?pageId=12059714  20220525 
 */
export const enableSubAccount = data => {
  return axios({
    url: '/profitsharemall/update',
    method: 'post',
    data
  })
}
/**
 * 分页查询
 * @param {*} data 
 * merchantName	否	string	分账商户名称
    schoolName	否	string	驾校名称
    trainType	否	string	培训车型
    mchId	否	string	商户号
    isReplace	否	string	是否代收 1:否 0:是
    isShare	否	string	是否开通分账 Y:开通 N:关闭
    district	否	string	地区
 * @wiki  http://wiki.sdjpw.com.cn/pages/viewpage.action?pageId=12059653  20220520
 */
export const page = data => {
  return axios({
    url: '/profitsharemall/list',
    method: 'post',
    data
  })
}
/**
 * 保存
 * @param {*} data 
 * isShare	是	String	是否开通分账 Y:开通 N:关闭
    trainType	是	String	培训车型
    id	否	String	分账管理Id 有就传，表示编辑
    merchantId	是	String	分账商户配置id
    merchantName	是	String	分账商户配置名称
    district	是	string	行政区划 /驾校下拉中district
    districtName	是	string	行政区划名称 驾校下拉中districtName
    amount	是	String	分账金额 单位：分
    schoolName	是	String	驾校名称
    schoolId	是	String	驾校ID
    isReplace	是	String	是否代收 1:否 0:是
 * @wiki  http://wiki.sdjpw.com.cn/pages/viewpage.action?pageId=12059664  20220520
 */
export const save = data => {
  return axios({
    url: '/profitsharemall/save',
    method: 'post',
    data,
  })
}
/**
 * 查询 全部商户号列表
 * @param {*} data 
 * name	否	string	商户名称
    schoolId	是	string	驾校Id
 * @wiki  http://wiki.sdjpw.com.cn/pages/viewpage.action?pageId=12059728  20220520
 */
export const listAccounter = data => {
  return axios({
    url: '/merchantmanage/optionMerchantManageList',
    method: 'post',
    data
  })
}
/**
 * 根据驾校获取分账配置
 * @param {*} data 
 * @wiki http://wiki.sdjpw.com.cn/pages/viewpage.action?pageId=12059661  20220520 
 */
export const listBySchoolId = data => {
  return axios({
    url: '/profitsharemall/ledgerAllocation',
    method: 'post',
    data
  })
}


// WEBPACK FOOTER //
// ./src/http/modules/sub-account.js